import { config, handleResponse } from '../../_helpers';

export const commodityService = {
    getAllCommodityGoods,
    loadCommodityGoods,
    getCommodityGoods,
    createCommodityGoods,
    updateCommodityGoods,
    deleteCommodityGoods,
    loadByCategory,
    readCommodityByCategory,
};
function loadByCategory(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CommodityGoods/loadByCategory`, requestOptions).then(handleResponse);
}
function readCommodityByCategory(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CommodityGoods/readCommodityByCategory`, requestOptions).then(handleResponse);
}
function getAllCommodityGoods() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CommodityGoods/getAllCommodity`, requestOptions).then(handleResponse);
}
function loadCommodityGoods(skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/CommodityGoods/load?skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/CommodityGoods/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getCommodityGoods(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CommodityGoods/getCommodityGoods/${id}`, requestOptions).then(handleResponse);
}
function createCommodityGoods(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CommodityGoods`, requestOptions).then(handleResponse);
}
function updateCommodityGoods(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CommodityGoods/update/${id}`, requestOptions).then(handleResponse);
}
function deleteCommodityGoods(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CommodityGoods/delete`, requestOptions).then(handleResponse);
}